module.exports = __webpack_public_path__ + "img/1371545603.ae30dfe0.jpg";